import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '@shared/services/language.service';
import {
  Auction,
  buildAuction,
} from '../../articles-manager/interfaces/auction.interface';
import { ArticleService } from '../../articles-manager/services/article.service';

@Component({
  selector: 'app-search-certificate-dialog',
  templateUrl: './search-certificate-dialog.component.html',
  styleUrls: ['./search-certificate-dialog.component.scss'],
  standalone: true,
  imports: [FormsModule, TranslatePipe],
})
@UntilDestroy()
export class SearchCertificateDialogComponent {
  // Signals for component state
  searchCode = signal<string>('');
  searchedAuction = signal<Auction>(buildAuction({}));
  isError = signal<boolean>(false);

  public activeModal = inject(NgbActiveModal);
  private languageService = inject(LanguageService);
  private router = inject(Router);
  private articleService = inject(ArticleService);

  searchCertificate() {
    const cleaned = this.searchCode().replace(/\s/g, '');
    this.searchCode.set(cleaned);
    if (cleaned !== '') {
      const lang = this.languageService.userSelectedLanguage.code;
      this.articleService
        .getArticleByCertificate(cleaned)
        .subscribe((responseBody) => {
          if (responseBody == null) {
            this.isError.set(true);
          } else {
            this.isError.set(false);
            const auction = responseBody;
            const infoList = auction.article.articleInfoList.find(
              (info) => info.languageCode == lang
            );
            if (infoList) {
              auction.article.articleInfoList = [infoList];
            }
            this.searchedAuction.set(auction);
            this.router.navigate(['/', lang, 'certificate', cleaned]);
            this.activeModal.close();
          }
        });
    }
  }
}
